import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/reorderPageSectionPdp/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { REORDER_SECTION_PAGE_PDP_EXPERIENCE } from 'constants/TestTarget';

const showReorderPageSectionPdpSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === REORDER_SECTION_PAGE_PDP_EXPERIENCE.CHALLENGER_ONE,
    challengerTwo: testReady && experience === REORDER_SECTION_PAGE_PDP_EXPERIENCE.CHALLENGER_TWO,
    challengerThree: testReady && experience === REORDER_SECTION_PAGE_PDP_EXPERIENCE.CHALLENGER_THREE
}));

export { showReorderPageSectionPdpSelector };
